module.exports = __webpack_public_path__ + "static/media/service-one.bd0ebb69.png";